import { Link } from "react-router-dom";
import { useState } from "react";
import {
  Newspaper, Calendar, ArrowLeft, Trophy, User, Flame, Star, MapPin, Clock, TrendingUp
} from "lucide-react";
import Logo from "@/components/Logo";

/**
 * Pàgina exclusiva de novetats i notícies dels atletes
 * + classificacions actuals i històriques resumides.
 */
export default function Noticies() {
  const [filter, setFilter] = useState("totes");

  const news = [
    {
      date: "5 Jul 2026",
      cat: "resultats",
      title: "Xavi Tomasa guanya el XIII Cross de Carme amb 19:11",
      excerpt: "Supera el ritme al km d'Albert Ferrer del 2003 (3:20,8/km enfront de 3:25/km). Jan Isla (19:37) i Marc Espinar (19:50) completen el podi. Jan Isla iguala el ritme històric.",
      tag: "Guanyador",
    },
    {
      date: "5 Jul 2026",
      cat: "resultats",
      title: "Anna Noguera s'imposa al sprint per davant de Jessica Ruiz",
      excerpt: "Anna Noguera (24:10) i Jessica Ruiz (24:13) protagonitzen un vibrant duel fins la meta. Maite Ríos completa el podi femení amb 24:50. Anna supera per la mínima el ritme de Carme Tort.",
      tag: "Guanyadora",
    },
    {
      date: "5 Jul 2026",
      cat: "rècords",
      title: "Berta Gabarró bat el rècord històric de la local femenina",
      excerpt: "Amb un temps de 29:41, Berta Gabarró aconsegueix la primera posició local femenina i estableix un nou rècord històric del Cross de Carme.",
      tag: "Rècord",
    },
    {
      date: "5 Jul 2026",
      cat: "rècords",
      title: "Domènec Sellarès signa el 6è millor ritme al km de la història local",
      excerpt: "Amb 24:14, Domènec Sellarès es converteix en el primer local masculí i aconsegueix el 6è millor ritme al quilòmetre de la història dels temps locals del Cross de Carme.",
      tag: "Local",
    },
    {
      date: "4 Jul 2026",
      cat: "novetats",
      title: "El nou circuit incorpora 240 metres addicionals",
      excerpt: "Aquesta edició estrena un traçat 240 metres més llarg que l'antic, cosa que dona un mèrit especial a les marques obtingudes i a la comparativa amb els rècords històrics.",
      tag: "Circuit",
    },
    {
      date: "5 Jul 2026",
      cat: "categories",
      title: "Guanyadors de totes les categories",
      excerpt: "Júnior F: Zoe Fortunati · Júnior M: Bernat Rueda · Sènior F: Jordina Martínez · Sènior M: Oriol Marín · +40 F: Susana Matarín · +40 M: Carlos Gámez · +50 F: M. Teresa Segués · +50 M: David Busquets.",
      tag: "Categories",
    },
  ];

  const cats = [
    { id: "totes", label: "Totes" },
    { id: "resultats", label: "Resultats" },
    { id: "rècords", label: "Rècords" },
    { id: "categories", label: "Categories" },
    { id: "novetats", label: "Novetats" },
  ];

  const filtered = filter === "totes" ? news : news.filter((n) => n.cat === filter);

  const topM = [
    { p: 1, n: "Xavi Tomasa", t: "19:11" },
    { p: 2, n: "Jan Isla", t: "19:37" },
    { p: 3, n: "Marc Espinar", t: "19:50" },
    { p: 4, n: "Oriol Marín", t: "20:01" },
    { p: 5, n: "Ferran Comas", t: "20:33" },
  ];
  const topF = [
    { p: 1, n: "Anna Noguera", t: "24:10" },
    { p: 2, n: "Jessica Ruiz", t: "24:13" },
    { p: 3, n: "Maite Ríos", t: "24:50" },
    { p: 4, n: "Jordina Martínez", t: "24:59" },
    { p: 5, n: "Míriam López", t: "25:31" },
  ];
  const historic = [
    { any: 2026, m: "Xavi Tomasa · 19:11", f: "Anna Noguera · 24:10" },
    { any: 2025, m: "Francesc Sedó · 21:17", f: "Marisol Ferragut · 43:18" },
    { any: 2024, m: "Roger Vives · 21:35", f: "Laura Mercader · 32:35" },
    { any: 2023, m: "David Borràs · 21:58", f: "Elena Segura · 29:57" },
    { any: 2022, m: "David Borràs · 21:36", f: "Montserrat Rocaginé · 32:05" },
    { any: 2003, m: "Francisco Llamas · 19:25", f: "Carme Tort · 23:17" },
    { any: 2002, m: "Albert Ferrer · 18:47", f: "Esperanza Zuriguel · 24:32" },
  ];

  return (
    <div className="min-h-screen bg-[#F7F1E8] text-[#15140F]">
      {/* Top bar */}
      <div className="bg-[#0E1410] text-[#F7F1E8] py-4 px-5 sm:px-8 border-b border-white/10">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <Link to="/" data-testid="noticies-back-home" className="inline-flex items-center gap-2 font-display uppercase tracking-wider text-xs text-[#F2B23A] hover:text-white transition-colors">
            <ArrowLeft size={16} /> Inici
          </Link>
          <Logo size="sm" onDark />
          <div className="hidden sm:flex items-center gap-2 text-[#F7F1E8]/60 text-xs font-display uppercase tracking-widest">
            <span className="w-2 h-2 bg-[#E94E1B] rounded-full pulse-dot" /> Actualitzat
          </div>
        </div>
      </div>

      {/* Hero */}
      <section className="relative bg-[#F7F1E8] py-16 md:py-20 px-5 sm:px-8 border-b border-[#15140F]/10 overflow-hidden">
        <div className="absolute -top-16 -right-16 w-72 h-72 stripes opacity-[0.08] rotate-12 pointer-events-none" />
        <div className="relative max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-tick" />
            <span className="font-display uppercase tracking-[0.28em] text-xs text-[#E94E1B]">
              Novetats · Atletes · Classificacions
            </span>
          </div>
          <h1 className="font-black uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.98]">
            Espai <span className="text-[#E94E1B]">atletes</span>
            <br />del Cross de Carme
          </h1>
          <p className="mt-5 text-base md:text-lg text-[#6B6358] max-w-3xl">
            La secció dedicada exclusivament a les novetats, notícies dels atletes i
            classificacions —tant les actuals com les històriques— del XIII Cross de Carme.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid lg:grid-cols-[2fr_1fr] gap-10">
        {/* News column */}
        <main>
          {/* Filters */}
          <div className="flex flex-wrap gap-2 mb-8">
            {cats.map((c) => (
              <button
                key={c.id}
                onClick={() => setFilter(c.id)}
                data-testid={`filter-${c.id}`}
                className={`px-4 py-2 font-display uppercase tracking-wider text-xs border transition-colors ${
                  filter === c.id
                    ? "bg-[#0E1410] text-white border-[#0E1410]"
                    : "bg-white text-[#15140F] border-[#15140F]/20 hover:border-[#E94E1B] hover:text-[#E94E1B]"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          {/* News list */}
          <div className="space-y-5">
            {filtered.map((n, i) => (
              <article
                key={i}
                className="bg-white border border-[#15140F]/10 p-6 md:p-7 hover:border-[#E94E1B] transition-colors group"
                data-testid={`news-${i}`}
              >
                <div className="flex items-center gap-3 mb-3 text-xs font-display uppercase tracking-widest">
                  <span className="inline-flex items-center gap-1 text-[#6B6358]">
                    <Calendar size={12} /> {n.date}
                  </span>
                  <span className="inline-flex items-center gap-1 bg-[#E94E1B] text-white px-2 py-0.5">
                    <Flame size={11} /> {n.tag}
                  </span>
                </div>
                <h2 className="font-black text-2xl md:text-3xl uppercase leading-tight group-hover:text-[#E94E1B] transition-colors">
                  {n.title}
                </h2>
                <p className="mt-3 text-[#15140F]/80 leading-relaxed">
                  {n.excerpt}
                </p>
              </article>
            ))}
            {filtered.length === 0 && (
              <div className="p-10 border-2 border-dashed border-[#15140F]/15 text-center text-[#6B6358]">
                No hi ha notícies en aquesta categoria.
              </div>
            )}
          </div>
        </main>

        {/* Sidebar · Classificacions */}
        <aside className="space-y-6 lg:sticky lg:top-24 self-start">
          <div className="bg-[#0E1410] text-[#F7F1E8] p-6 border-l-4 border-[#E94E1B]">
            <div className="flex items-center gap-2 font-display uppercase tracking-[0.22em] text-[10px] text-[#F2B23A] mb-3">
              <Trophy size={14} /> Top 5 · XIII edició 2026
            </div>
            <div>
              <div className="text-[10px] font-display uppercase tracking-widest text-[#F2B23A] mb-2">Masculí</div>
              <ul className="text-sm divide-y divide-white/10">
                {topM.map((r) => (
                  <li key={"m" + r.p} className="flex items-center gap-3 py-2">
                    <span className={`w-6 h-6 flex items-center justify-center font-black text-xs ${r.p === 1 ? "bg-[#E94E1B] text-white" : "bg-white/10 text-white"}`}>{r.p}</span>
                    <span className="flex-1 font-display uppercase">{r.n}</span>
                    <span className="tabular-nums font-bold text-[#F2B23A]">{r.t}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-5">
              <div className="text-[10px] font-display uppercase tracking-widest text-[#F2B23A] mb-2">Femení</div>
              <ul className="text-sm divide-y divide-white/10">
                {topF.map((r) => (
                  <li key={"f" + r.p} className="flex items-center gap-3 py-2">
                    <span className={`w-6 h-6 flex items-center justify-center font-black text-xs ${r.p === 1 ? "bg-[#E94E1B] text-white" : "bg-white/10 text-white"}`}>{r.p}</span>
                    <span className="flex-1 font-display uppercase">{r.n}</span>
                    <span className="tabular-nums font-bold text-[#F2B23A]">{r.t}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Link to="/#resultats" className="mt-5 inline-flex items-center gap-2 border border-white/40 text-white px-4 py-2 font-display uppercase tracking-wider text-xs hover:bg-white hover:text-[#0E1410] transition-colors">
              Veure top 10 complet
            </Link>
          </div>

          <div className="bg-white border border-[#15140F]/10 p-6">
            <div className="flex items-center gap-2 font-display uppercase tracking-[0.22em] text-[10px] text-[#E94E1B] mb-3">
              <TrendingUp size={14} /> Palmarès resumit
            </div>
            <ul className="text-sm divide-y divide-[#15140F]/10">
              {historic.map((h) => (
                <li key={h.any} className="py-3">
                  <div className="font-black text-lg font-display leading-none text-[#E94E1B]">{h.any}</div>
                  <div className="mt-1 text-[13px]"><span className="text-[#6B6358] font-display uppercase text-[10px] tracking-widest">M · </span>{h.m}</div>
                  <div className="text-[13px]"><span className="text-[#6B6358] font-display uppercase text-[10px] tracking-widest">F · </span>{h.f}</div>
                </li>
              ))}
            </ul>
            <Link to="/#classificacio" className="mt-4 inline-flex items-center gap-2 border border-[#0E1410]/20 text-[#15140F] px-4 py-2 font-display uppercase tracking-wider text-xs hover:bg-[#0E1410] hover:text-white transition-colors">
              Palmarès complet
            </Link>
          </div>

          <a
            href="https://sportmaniacs.com/es/services/inscription/xiii-cross-de-carme-i-iv-marxa-de-carme-ets-tu"
            target="_blank"
            rel="noreferrer"
            className="block bg-[#E94E1B] text-white p-5 hover:bg-[#C03A12] transition-colors"
          >
            <div className="font-display uppercase tracking-widest text-[10px] text-white/80">Classificació oficial</div>
            <div className="font-black text-lg mt-1">Sportmaniacs →</div>
          </a>
        </aside>
      </div>

      {/* Footer */}
      <footer className="bg-[#0E1410] text-[#F7F1E8] py-8 px-5 sm:px-8 border-t border-white/10">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
          <div>© 2026 · Espai atletes · XIII Cross de Carme</div>
          <Link to="/" className="text-[#F2B23A] hover:text-white transition-colors font-display uppercase tracking-wider">
            Tornar a l'inici
          </Link>
        </div>
      </footer>
    </div>
  );
}
